import React from "react";
import { useQuery } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BASE_PATH, getDetailContent, IDetail } from "api/commonApi";
import { redirectURL } from "utils/CommonFunc";
import { IMAGE_DNS } from "utils/config/Config";
import CommonInput from "components/community/pageRight/CommonInput/CommonInput";
import Reply from "components/community/pageRight/Reply/Reply";
import Social from "components/community/pageRight/Social/Social";
import "./DetailPage.scss";
import { useRecoilValue } from "recoil";
import {
  isEditState,
  isProfilePageState,
  isThroughMainState
} from "recoil/contentsAtom";
import DetailLoading from "components/common/loading/DetailLoading";
import IsMyArticle from "components/community/common/isMyarticle/IsMyArticle";
import ContentsTags from "components/community/common/ContentsTags";
import { PhotoAlbum } from "react-photo-album";
import {
  headersState,
  isLauncherState,
  isLoginStateSelector,
  isPrivacyAgreeState,
  userInfoState
} from "recoil/userInfoAtom";
import { t } from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

function DetailPage() {
  const { service_code, title, idx, profilekey } = useParams();
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const userInfo = useRecoilValue(userInfoState);
  const headers = useRecoilValue(headersState);
  const navigate = useNavigate();
  const isThroughMain = useRecoilValue(isThroughMainState);
  const isPrivacyAgree = useRecoilValue(isPrivacyAgreeState);
  const isLauncher = useRecoilValue(isLauncherState);
  const isProfilePage = useRecoilValue(isProfilePageState);
  const isEdit = useRecoilValue(isEditState);

  const api = isProfilePage
    ? `${BASE_PATH}/api/vfunlounge/profile/post/${idx}`
    : `${BASE_PATH}/api/vfunlounge/posts/${service_code}/${title}/${idx}`;

  const { isLoading, data } = useQuery<IDetail>(
    ["detailContent", idx, isEdit],
    () => getDetailContent(headers, api),
    {
      refetchOnWindowFocus: false,
      notifyOnChangeProps: "tracked"
    }
  );

  const onClickX = () => {
    if (isThroughMain) {
      navigate(-1);
      return;
    }

    if (isProfilePage) {
      redirectURL(
        `${window.location.origin}/profile/${profilekey}/post`,
        "_self",
        isLauncher
      );
      return;
    }

    redirectURL(
      `${window.location.origin}/page/${service_code}`,
      "_self",
      isLauncher
    );
  };

  const min = 128;
  const max = 640;
  const randomHeight = Math.floor(Math.random() * (max - min + 1)) + min;

  const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

  const photos = (imgs: any) => {
    const data = imgs.map((photo: string) => ({
      src: photo,
      width: 1080,
      height: 800,
      srcSet: breakpoints.map((breakpoint) => {
        const height = randomHeight;
        return {
          src: photo,
          width: breakpoint,
          height
        };
      })
    }));

    return data;
  };

  return (
    <div className="layer-wrap article-type" id="DetailPage">
      <div className="shadow" onClick={onClickX} />
      <div className="pop-layer">
        <Link className="btn-layer-close" to="#" onClick={onClickX}>
          <FontAwesomeIcon icon={faXmark} />
        </Link>

        {!isLoading ? (
          data?.result === 1 ? (
            <div className="pop-container article clearfix">
              <h1 className="clearfix popUp-top">{t("view_post")}</h1>
              <div className="frame">
                <div className="info">
                  <img
                    className="user-pic"
                    src={
                      data.data.admin_flag === 0
                        ? data.data.profile_image_url_from !== "" &&
                          data.data.profile_image_url_from !== null
                          ? data.data.profile_image_url_from
                          : IMAGE_DNS +
                            "/Valofe_file/web/vfun/images/common/img-user-default-min.png"
                        : data.data.admin_icon
                    }
                    alt="user icon"
                  />
                  <div>
                    <IsMyArticle
                      idx={data.data.idx}
                      isWriter={
                        isProfilePage
                          ? Number(data.data.user_Serial_from) ===
                            userInfo.userSerial
                          : data.data.user_id === userInfo.Userid
                      }
                      nickname={{
                        to: isProfilePage
                          ? data.data.user_nickname_to
                          : data.data.user_nickname,
                        from: isProfilePage
                          ? data.data.user_nickname_from
                          : data.data.user_nickname
                      }}
                      serialNum={
                        isProfilePage
                          ? {
                              to: data.data.user_Serial_to as number,
                              from: data.data.user_Serial_from as number
                            }
                          : {
                              to: userInfo.userSerial,
                              from: userInfo.userSerial
                            }
                      }
                      profilekey={data.data.profile_key}
                    />

                    <div className="date">{data?.data.created_at}</div>
                  </div>
                </div>

                <div className="cont clearfix">
                  <ContentsTags
                    data={data?.data.title}
                    className="title"
                    admin={data.data.admin_flag}
                  />
                  <ContentsTags
                    data={data?.data.content}
                    className="text"
                    admin={data.data.admin_flag}
                  />
                  {data?.data.images !== null &&
                  data?.data.images.length !== 0 ? (
                    <div
                      className={`detailTxt ${
                        data?.data.images.length === 1 ? "img-ea-1" : ""
                      }`}
                    >
                      <PhotoAlbum
                        photos={photos(data.data.images)}
                        layout="rows"
                      />
                    </div>
                  ) : null}
                </div>
              </div>

              <Social
                likeCount={data?.data.like_count}
                commentCount={data?.data.comments_count}
                idx={data.data.idx}
                userLike={data.data.user_like_status}
              />

              <CommonInput
                type={
                  isLoginState.isLogIn
                    ? isPrivacyAgree
                      ? "reply"
                      : "privacyAgree"
                    : "login"
                }
              />
              {data?.data.comments_count !== 0 && <Reply />}
            </div>
          ) : null
        ) : (
          <DetailLoading />
        )}
      </div>
    </div>
  );
}

export default DetailPage;
